var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flipCard",class:{ fold: _vm.animation === 'fold', unfold: _vm.animation === 'unfold' }},[_c('span',[_vm._v(_vm._s(_vm.digit))])])}
var staticRenderFns = []

export { render, staticRenderFns }